
import productsMixin from './mixins/products'

const LIMIT = 18

// Настройки SEO полей head
const SEO = {
  TITLE: 'События | Мегасреда',
  DESCRIPTION: 'Ближайшие события от компаний и пользователей Мегасреды',
  H1: 'События в ближайшее время',
  IMAGE: {
    url: 'https://megasreda.ru/img/products/events_ogg.jpg',
    urlVk: 'https://megasreda.ru/img/products/events_ogg-vk.jpg',
    urlTw: 'https://megasreda.ru/img/products/events_ogg.jpg',
    type: 'image/jpeg',
    width: 1200,
    height: 630,
  },
}

export default {
  mixins: [productsMixin],
  scrollToTop: true,

  async asyncData({ $axios }) {
    const { products, countAllPublishedProducts } = await $axios.$get(
      'advertisements/events/in/streams',
      {
        params: {
          limit: LIMIT,
          offset: 0,
        },
      }
    )
    return {
      products,
      productsCount: countAllPublishedProducts,
    }
  },

  computed: {
    seoTitle() {
      return SEO.TITLE
    },
    seoDescription() {
      return SEO.DESCRIPTION
    },
    seoH1() {
      return SEO.H1
    },
    seoImage() {
      return SEO.IMAGE
    },
    pageCount() {
      return Math.ceil(this.productsCount / LIMIT)
    },
    productsOffset() {
      return (this.page - 1) * LIMIT
    },
  },

  methods: {
    async fetchProducts() {
      const { products, countAllPublishedProducts } = await this.$axios.$get(
        'advertisements/events/in/streams',
        {
          params: {
            limit: LIMIT,
            offset: this.productsOffset,
          },
        }
      )

      this.productsCount = countAllPublishedProducts

      this.products = this.products?.length
        ? this.products.concat(products)
        : products
    },
  },
}
